import React from "react";
import { useTranslation } from "react-i18next";
import { FilterIconImage } from "../../../assets/logos/icons";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import cellDetailSignatureHistory from "./cellDetailSignatureHistory";
import ConfigurationSignatureHistoryDetailView from "../../views/configuration-signature-history-detail/configuration-signature-history-detail.view";
import "./configuration-signature-history-panel.pure.css";
import moment from "moment";
import "moment/locale/es";

/* === Custom Component for th elements of the Grid === */
const SignRequestCellHeader = (props) => {
  const cellHeaderStyles = {
    color: "#123513",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    justifyContent: "start",
    fontFamily: "Quicksand",
  };
  return <span style={cellHeaderStyles}>{props.title}</span>;
};

/* === Custom componente for td elements of the Grid === */
const SignRequestStatusCell = (props) => {
  const stateSignature = props.dataItem.signStatusName;
  let colorItem = "";
  if (stateSignature) {
    if (stateSignature === "Firmado") {
      colorItem = "#7B8C42";
    } else if (stateSignature === "Pendiente") {
      colorItem = "#005DA1";
    } else if (stateSignature === "Rechazado") {
      colorItem = "#E73C32";
    } else if (stateSignature === "Cancelado") {
      colorItem = "#FF922C";
    } else {
      colorItem = "#4c4c4c";
    }
  }

  return <td style={{ color: `${colorItem}` }}>{stateSignature}</td>;
};

/* === Custom componente for td elements of the Grid === */
const SignRequestCell = (props) => {
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

const SignRequestSignsUsedCell = (props) => {
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };
  return (
    <td id="signsUsed" style={cellItemStyles}>
      {props.dataItem[props.field]}
    </td>
  );
};

const SignRequestCellDate = (props) => {
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    textTransform: "capitalize",
    fontFamily: "Quicksand ",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };
  return (
    <td id={`${props.field}`} style={cellItemStyles}>
      {props.dataItem[props.field]}
    </td>
  );
};

/* === Pure component Grid of SignatureRequestPanel === */
const ConfigurationSignatureHistoryPanelPure = (props) => {
  const { t } = useTranslation();

  const gridSignatureRequestPanelStyle = {
    height: "470px",
  };
  const gridColumnNoRecordsStyle = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Quicksand, sans-serif",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  };

  moment.locale("es");
  let signatureRequests = "";
  if (props.signatureRequests.length > 0) {
    signatureRequests = props.signatureRequests.map((item) => ({
      ...item,
      createdDate: moment(item.createdDate)
        .format("DD/MMM/YYYY")
        .replace(/\./g, ""),
    }));
  }

  return (
    <div>
      {/* <Traslates> */}
      <div className="configurationSignatureHistoryPanelPure-filterContainerStyle">
        <img src={FilterIconImage} alt='icon' className='configurationSignatureHistoryPanelPure-filterIcon-style'></img>
        <select
          className="configurationSignatureHistoryPanelPure-filter-style"
          onChange={props.onFilterContracts}
          value={props.contractId}
        >
          <option value="0">
            {t("configurationSignatureHistoryPanel.filterDefault")}
          </option>
          {props.optionsContracts}
        </select>
      </div>
      <Grid
        className="configurationSignatureHistoryPanelPure-historic"
        style={gridSignatureRequestPanelStyle}
        data={signatureRequests.slice(props.skip, props.take + props.skip)}
        resizable
        reorderable
        skip={props.skip}
        take={props.take}
        pageable={props.showPagination}
        total={signatureRequests.length}
        onPageChange={props.onPageChange}
      >
        <GridColumn
          field="shortId"
          title={t("configurationSignatureHistoryPanel.contractSerial")}
          width="auto"
          cell={SignRequestCell}
          headerCell={SignRequestCellHeader}
          filterable
        />
        <GridColumn
          field="createdDate"
          title={t("configurationSignatureHistoryPanel.date")}
          width="auto"
          cell={SignRequestCellDate}
          headerCell={SignRequestCellHeader}
          filterable
        />
        <GridColumn
          field="name"
          title={t("configurationSignatureHistoryPanel.request")}
          width="auto"
          cell={SignRequestCell}
          headerCell={SignRequestCellHeader}
          filterable
        />
        <GridColumn
          field="signStatusName"
          title={t("configurationSignatureHistoryPanel.state")}
          width="auto"
          cell={SignRequestStatusCell}
          headerCell={SignRequestCellHeader}
          filterable={false}
        />
        <GridColumn
          field="signsUsed"
          title={t("configurationSignatureHistoryPanel.totalSigns")}
          width="auto"
          cell={SignRequestSignsUsedCell}
          headerCell={SignRequestCellHeader}
          filterable
        />
        <GridColumn
          field="actions"
          title={t("configurationSignatureHistoryPanel.action")}
          width="auto"
          headerCell={SignRequestCellHeader}
          cell={cellDetailSignatureHistory(
            props.buttonClass,
            props.edit,
            props.seeDetail,
            props.view
          )}
        />
        <GridNoRecords>
          <span style={gridColumnNoRecordsStyle}>
            {t("configurationSignatureHistoryPanel.notResults")}
          </span>
        </GridNoRecords>
        {props.signatureInEdit && (
          <ConfigurationSignatureHistoryDetailView
            {...props}
            dataItem={props.signatureInEdit}
            edit={props.edit}
            onChangeSignatureRequest={props.onChangeSignatureRequest}
            onDialogInputChange={props.onDialogInputChange}
          />
        )}
      </Grid>
      {/* </Traslates> */}
    </div>
  );
};
export { ConfigurationSignatureHistoryPanelPure as default };
